export default "__VITE_ASSET__CJO61_SY__";